import _ from 'lodash';

import * as constants from './TrainingCamps.constants';
import * as services from './TrainingCamps.service';

const state = {
  xlyList: [],
  isRequest: false,
};

const mutations = {
  [constants.GET_TASK_STATUS_SUCCESS](state, xlyList) {
    if (undefined !== xlyList && null !== xlyList) {
      state.xlyList = xlyList;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getCourseMultiTaskStatus({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getCourseMultiTaskStatus(payload);
    commit(constants.GET_TASK_STATUS_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  xlyList: (state) =>
    _.map(state.xlyList, (xlyClass) => ({
      ...xlyClass,
      c_percent: xlyClass.xlyTotalCount
        ? Math.floor((xlyClass.xlyFinishedCount / xlyClass.xlyTotalCount) * 100)
        : 0,
    })),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
